const TOGGLE_MENU_DISPLAY = "TOGGLE_MENU_DISPLAY";
const FETCH_MENU_KEY = "FETCH_MENU_KEY";
const UPDATE_PROFILE_DETAIL = "UPDATE_PROFILE_DETAIL";
const INITIAL_PROFILE_DETAIL = "INITIAL_PROFILE_DETAIL";
const TOGGLE_DRAWER_MENU = "TOGGLE_DRAWER_MENU";
const REVISION_PRICE_INFO = "REVISION_PRICE_INFO";
const REVISION_PRICE_STEP = "REVISION_PRICE_STEP";
const REVISION_PRICE_LOGS = "REVISION_PRICE_LOGS";
const REVISION_PRICE_RATE = "REVISION_PRICE_RATE";
const REVISION_PRICE_ID = "REVISION_PRICE_ID";
const NEXT_REVISION_INFO = "NEXT_REVISION_INFO";

export {
  TOGGLE_MENU_DISPLAY,
  FETCH_MENU_KEY,
  UPDATE_PROFILE_DETAIL,
  INITIAL_PROFILE_DETAIL,
  TOGGLE_DRAWER_MENU,
  REVISION_PRICE_INFO,
  REVISION_PRICE_STEP,
  REVISION_PRICE_LOGS,
  REVISION_PRICE_RATE,
  REVISION_PRICE_ID,
  NEXT_REVISION_INFO,
};



// WEBPACK FOOTER //
// ./src/store/actionTypes.js